import type { ChatAssetItem } from "schemas/generated/chatMessage";

import React, { useState } from "react";

import { VIDEO_ACCEPT_FILE_EXTENSIONS } from "@v2/features/assets/constants";
import { formatAssetDisplayName } from "@v2/features/assets/utils/formatAssetDisplayName";
import { ImageOverlay } from "@v2/features/chat/components/chat-elements/chat-message/ImageOverlay";
import { VideoThumbnail } from "@v2/features/chat/components/chat-elements/VideoThumbnail";

export const AssetToken = ({ data }: { data: ChatAssetItem }) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const displayName = formatAssetDisplayName(data.name);
  const isVideo = VIDEO_ACCEPT_FILE_EXTENSIONS.includes(
    `.${data.fileExtension.toLowerCase()}`,
  );

  const handleImageClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOverlayOpen(true);
  };

  return (
    <>
      <span
        className={`inline-flex items-center align-middle max-w-full p-1 border-[0.5px] border-border bg-sheet rounded-md${!isVideo ? " cursor-pointer hover:opacity-80 transition-opacity" : ""}`}
        onClick={!isVideo ? handleImageClick : undefined}
      >
        {isVideo ? (
          <VideoThumbnail src={data.url} size="xs" className="mr-1" />
        ) : (
          <img
            src={data.url}
            alt={displayName}
            className="w-5 h-5 object-cover rounded-sm inline align-baseline mr-1 border border-border"
          />
        )}
        <span className="font-medium text-default truncate">
          {displayName}.{data.fileExtension}
        </span>
      </span>
      {!isVideo && (
        <ImageOverlay
          isOpen={isOverlayOpen}
          onClose={() => setIsOverlayOpen(false)}
          imageSrc={data.url}
          imageAlt={displayName}
        />
      )}
    </>
  );
};
